import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const MobileBottomTabBar = ({ activeColumn, setActiveColumn }) => {
  const { t } = useTranslation();
  
  return (
    <Box sx={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      height: 'calc(60px + env(safe-area-inset-bottom))',
      bgcolor: '#fff',
      borderTop: '1px solid rgba(0, 0, 0, 0.1)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
      paddingBottom: 'env(safe-area-inset-bottom)',
      zIndex: 1000,
      boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)'
    }}>
      {/* 플레이어 탭 */}
      <Box
        onClick={() => {
          if (navigator.vibrate) navigator.vibrate(50);
          setActiveColumn(0);
        }}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 1,
          py: 0.5,
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          '&:active': {
            transform: 'scale(0.95)',
            opacity: 0.7
          }
        }}
      >
        <Box sx={{
          width: 22,
          height: 22,
          mb: 0.3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: activeColumn === 0 ? '#007AFF' : '#8E8E93' // iOS 블루 / 그레이
        }}>
          {/* 플레이어 아이콘 */}
          <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
            <path d="M8 5v14l11-7z"/>
          </svg>
        </Box>
        <Typography sx={{
          fontSize: '9px',
          fontWeight: activeColumn === 0 ? 600 : 400,
          color: activeColumn === 0 ? '#007AFF' : '#8E8E93',
          lineHeight: 1
        }}>
          {t('mobile.tabPlayer')}
        </Typography>
      </Box>

      {/* 분석결과 탭 */}
      <Box
        onClick={() => {
          if (navigator.vibrate) navigator.vibrate(50);
          setActiveColumn(1);
        }}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 1,
          py: 0.5,
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          '&:active': {
            transform: 'scale(0.95)',
            opacity: 0.7
          }
        }}
      >
        <Box sx={{
          width: 22,
          height: 22,
          mb: 0.3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: activeColumn === 1 ? '#007AFF' : '#8E8E93'
        }}>
          {/* 분석결과 아이콘 */}
          <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
          </svg>
        </Box>
        <Typography sx={{
          fontSize: '9px',
          fontWeight: activeColumn === 1 ? 600 : 400,
          color: activeColumn === 1 ? '#007AFF' : '#8E8E93',
          lineHeight: 1
        }}>
          {t('mobile.tabAnalysis')}
        </Typography>
      </Box>

      {/* AI와 대화 탭 */}
      <Box
        onClick={() => {
          if (navigator.vibrate) navigator.vibrate(50);
          setActiveColumn(2);
        }}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 1,
          py: 0.5,
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          '&:active': {
            transform: 'scale(0.95)',
            opacity: 0.7
          }
        }}
      >
        <Box sx={{
          width: 22,
          height: 22,
          mb: 0.3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: activeColumn === 2 ? '#007AFF' : '#8E8E93'
        }}>
          {/* AI 대화 아이콘 */}
          <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12,3C17.5,3 22,6.58 22,11C22,15.42 17.5,19 12,19C10.76,19 9.57,18.82 8.47,18.5C5.55,21 2,21 2,21C4.33,18.67 4.7,17.1 4.75,16.5C3.05,15.07 2,13.13 2,11C2,6.58 6.5,3 12,3Z"/>
          </svg>
        </Box>
        <Typography sx={{
          fontSize: '9px',
          fontWeight: activeColumn === 2 ? 600 : 400,
          color: activeColumn === 2 ? '#007AFF' : '#8E8E93',
          lineHeight: 1
        }}>
          {t('mobile.tabChat')}
        </Typography>
      </Box>
    </Box>
  );
};

export default MobileBottomTabBar; 